module.exports = __webpack_public_path__ + "static/img/icon-07.dea312b0.png";